import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.25 19.25H4.75a2 2 0 0 1-2-2V4.75a2 2 0 0 1 2-2h12.5a2 2 0 0 1 2 2v12.5a2 2 0 0 1-2 2M8.708 19.25V2.75" }, null, -1),
    _createElementVNode("path", { d: "M5.042 9.167 6.646 11l-1.604 1.833" }, null, -1)
  ]))]))
}
export default { render: render }